import { render, staticRenderFns } from "./PdfSvg.vue?vue&type=template&id=a6814cfe&"
import script from "./PdfSvg.vue?vue&type=script&lang=js&"
export * from "./PdfSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports